<script lang="ts">
  import Icon from '../icon/icon.svelte';
  import { DieFace } from '../models/face.type';

  interface Props {
    face: Array<DieFace>;
    sizeMod?: number;
  }

  let { face, sizeMod = 0 }: Props = $props();

  let icons = $derived(
    face.filter((facc) => {
      return facc !== DieFace.OR;
    }),
  );
  let isSplit = $derived(face.indexOf(DieFace.OR) !== -1);

  let size = $derived.by(() => {
    switch (icons.length + sizeMod) {
      case 1:
        return 100; //40*(sizeMod/100);
      case 2:
        return 75; //30*(sizeMod/100);
      case 3:
        return 50; //25*(sizeMod/100);
      case 4:
        return 25; //25*(sizeMod/100);
    }
    return 20;
  });
</script>

{#each icons as icon, index}
  <div class="icon icon-{size}">
    <Icon name={icon} />
  </div>

  {#if isSplit && index != icons.length - 1}
    <div class="vr" style="height: 75%;"></div>
  {/if}
{/each}

<style lang="less">
  @import '../../defines.less';

  .icon {
    display: flex;
  }
  :global(.icon-100) {
    --icon-size: 40px;
  }
  :global(.icon-75) {
    --icon-size: 30px;
  }
  :global(.icon-50) {
    --icon-size: 20px;
  }
  :global(.icon-25) {
    --icon-size: 15px;
  }

  @media @medium {
    :global(.icon-100) {
      --icon-size: 35px;
    }
    :global(.icon-75) {
      --icon-size: 22px;
    }
    :global(.icon-50) {
      --icon-size: 15px;
    }
    :global(.icon-25) {
      --icon-size: 12px;
    }
  }

  @media @small {
    :global(.icon-100) {
      --icon-size: 23px;
    }
    :global(.icon-75) {
      --icon-size: 17px;
    }
    :global(.icon-50) {
      --icon-size: 15px;
    }
    :global(.icon-25) {
      --icon-size: 12px;
    }
  }

  .vr {
    z-index: 1;
    width: 1px;
    margin: 0 2px;
    background: linear-gradient(to top, transparent, #fff, transparent);
  }
</style>
